import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'
import { requestUndoSupersedSite } from 'api/site'

import { SiteSupersedeModalFooter, SiteSupersedeModalFooterButtonWrapper, SiteSupersedeModalText } from './style'


const SiteRevertStatusModal = ({ site, toggleModal, getSite }) => {
  const closeModal = () => {
    toggleModal({})
  }

  const revertSupersededStatus = () => {
    requestUndoSupersedSite(site.id).then((data) => {
      toggleModal({})
      getSite()
    })
  }

  return (
    <>
      <SiteSupersedeModalText>
        <FormattedMessage id="changeStatusToConfirmFromSupersede" values={{ name: <b>{site.name}</b> }} />
      </SiteSupersedeModalText>
      <SiteSupersedeModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <SiteSupersedeModalFooterButtonWrapper>
          <Button type="primary" onClick={revertSupersededStatus}>
            <FormattedMessage id="changeStatus" />
          </Button>
        </SiteSupersedeModalFooterButtonWrapper>
      </SiteSupersedeModalFooter>
    </>
  )
}

export default SiteRevertStatusModal
